<template>
  <v-container
    id="eligibilityGroupSummary"
  >
    <v-progress-linear
      v-show="loading"
      indeterminate
      color="green"
    />
    <div>
      <div class="oe-summary-title">
        <v-btn
          class="mx-2"
          fab
          dark
          x-small
          :color="approvals.color"
          @click="displaySection = !displaySection"
        >
          <v-icon
            v-show="!displaySection"
            dark
          >
            mdi-arrow-expand-vertical
          </v-icon>
          <v-icon
            v-show="displaySection"
            dark
          >
            mdi-arrow-expand-horizontal
          </v-icon>
        </v-btn>
        Eligibility Group Summary
      </div>
      <v-fab-transition>
        <note
          v-show="displaySection"
          :open-enrollment="openEnrollment"
          :section="sections.eligibilityGroup"
          summary="true"
        />
      </v-fab-transition>
      <v-container
        v-if="!loading && eligibilityGroups && eligibilityGroups.length"
        fluid
      >
        <v-row dense>
          <v-col
            v-for="(group, i) in groups"
            :key="i"
          >
            <v-fab-transition>
              <v-card
                v-show="displaySection"
                class="location-summary"
              >
                <v-card-text>
                  <div class="display-2 text--primary">
                    <span v-text="group.eligibilityGroup" />
                  </div>
                  <div
                    class="display-1 text--primary"
                  >
                    <ul
                      v-for="(detail, j) in getGroupDetails(group.oeEligibilityGroupId)"
                      :key="j"
                    >
                      <li>
                        {{ detail.locationName }} - {{ detail.jobClassName }}
                      </li>
                    </ul>
                  </div>
                </v-card-text>
              </v-card>
            </v-fab-transition>
          </v-col>
        </v-row>
      </v-container>
      <v-fab-transition>
        <v-alert
          v-show="displaySection && (!loading && (!eligibilityGroups || !eligibilityGroups.length))"
          type="info"
        >
          No eligibility group details found
        </v-alert>
      </v-fab-transition>
      <v-fab-transition>
        <approval
          v-show="displaySection"
          :approvals="approvals"
          :allow-change="!print"
          @approval:changed="$emit('approval:changed')"
        />
      </v-fab-transition>
    </div>
    <base-material-snackbar
      v-model="displayError"
      type="error"
      v-bind="{
        top: true,
        right: true
      }"
    >
      {{ errorMessage }}
    </base-material-snackbar>
  </v-container>
</template>

<script>
  import TroodyApi from '@/services/troody/TroodyApi'
  import Approvals from '@/services/troody/Approvals'

  export default {
    name: 'EligibilityGroupSummary',

    components: {
      Note: () => import('./Note'),
      Approval: () => import('./Approval'),
    },

    props: {
      expanded: {
        type: Boolean,
        default: false,
      },
      openEnrollment: {
        type: Object,
        default: null,
      },
      print: {
        type: Boolean,
        default: false,
      },
    },

    data: () => ({
      displaySection: true,

      loadingEligibilityGroups: false,

      errorMessage: null,
      displayError: false,
      formErrors: {},

      eligibilityGroups: null,

      eligibilityGroupDetailResource: new TroodyApi('oeEligibilityGroupDetail/'),
      approvals: null,
    }),

    computed: {
      loading () {
        return (this.loadingEligibilityGroups)
      },

      sections () {
        return Approvals.sections
      },

      groups () {
        let groups = null
        if (this.eligibilityGroups && this.eligibilityGroups.length) {
          const groupIdList = []
          groups = []
          this.eligibilityGroups.forEach((group) => {
            if (!groupIdList.includes(group.oeEligibilityGroupId)) {
              groupIdList.push(group.oeEligibilityGroupId)
              groups.push({
                oeEligibilityGroupId: group.oeEligibilityGroupId,
                eligibilityGroup: group.eligibilityGroup,
              })
            }
          })
        }
        return groups
      },
    },

    watch: {
      expanded (val) {
        this.displaySection = val
      },
    },

    created () {
      this.initialize()
    },

    methods: {
      initialize () {
        this.formErrors = {}
        this.loadEligibilityGroups()
        this.approvals = new Approvals(this.openEnrollment.id, Approvals.sections.eligibilityGroup.id)
        this.displaySection = this.expanded
      },

      getGroupDetails (oeEligibilityGroupId) {
        let list = null

        if (this.eligibilityGroups && this.eligibilityGroups.length) {
          list = this.eligibilityGroups.filter((group) => {
            return group.oeEligibilityGroupId === oeEligibilityGroupId
          })
        }

        return list
      },

      loadEligibilityGroups () {
        this.loadingEligibilityGroups = true
        this.eligibilityGroupDetailResource.query({ openEnrollmentId: this.openEnrollment.id })
          .then(data => {
            console.log('eligibilityGroup')
            console.log(data)
            this.loadingEligibilityGroups = false
            this.eligibilityGroups = data
          })
          .catch((error) => {
            this.loadingEligibilityGroups = false
            this.eligibilityGroups = null
            this.showError(error, 'Failed to load eligibility group details!')
          })
      },

      showError (error, msg) {
        console.log(error)
        this.errorMessage = (error || msg)
        this.displayError = true
      },
    },
  }
</script>

<style lang="sass">
  .eligibility-group-summary
    border-width: 3px
    border-style: solid
    border-color: rgba(0, 255, 0, 0.1) !important
    border-radius: 10px !important
    margin: 4px !important
</style>
